export const INNOCHAT_SET_USER = 'INNOCHAT_SET_USER';
export const INNOCHAT_RESET = 'INNOCHAT_RESET';

export const ANALYTICS_IDENTITY = 'ANALYTICS_IDENTITY';
export const ANALYTICS_RESET = 'ANALYTICS_RESET';
